export default {
    'CONTACT.DETAILS.INPUT.FIRST_NAME.LABEL': 'Prénom',
    'CONTACT.DETAILS.INPUT.LAST_NAME.LABEL': 'Nom de famille',
    'CONTACT.DETAILS.INPUT.PHONE.LABEL': 'Téléphone',
    'CONTACT.DETAILS.INPUT.COMPANY.LABEL': 'Société',
    'CONTACT.DETAILS.INPUT.COLOR.LABEL': 'Couleur',
    'CONTACT.DETAILS.HINT.REQUIRED': 'Сhamps requis',
};
